// extracted by mini-css-extract-plugin
export default {"filtersContainer":"student-filters_filtersContainer__i7CXS","dropdownContainer":"student-filters_dropdownContainer__SBHsr","marginRight10":"student-filters_marginRight10__T7+-M"};